import config from 'config';
import * as yup from 'yup';
import * as t from 'data';
import { every, isEmpty } from 'lodash';
import { Place } from 'types';

const {
  phonePattern,
  regex: { noLatinChar },
} = config;

export const contactDetailsSchema = yup.object().shape({
  salutation: yup.string().required(t.global.validators.required),
  firstname: yup.string().required(t.global.validators.required),
  lastname: yup.string().required(t.global.validators.required),
  email: yup
    .string()
    .required(t.global.validators.required)
    .email(t.global.validators.email)
    .matches(noLatinChar, t.global.validators.noLatinChar),
  phone: yup
    .string()
    .required(t.global.validators.required)
    .test('is-phone', t.global.validators.wrongPhoneNumber, phone => phonePattern.test(phone)),
});

export const placeSchema = yup
  .mixed()
  .test(
    'place',
    t.global.validators.required,
    (place: Partial<Place>) =>
      !isEmpty(place) && every(place, value => typeof value !== 'undefined'),
  );
